import { of, timer } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AppStore } from 'app/shared/store/app.store';
import * as i0 from "@angular/core";
import * as i1 from "../store/app.store";
/**
 * Implémentation de PreloadingStrategy.
 * Les modules ayant "preload: true" dans leur données de route sont préchargés.
 */
export class CustomPreloadingStrategyService {
    constructor(appStore) {
        this.appStore = appStore;
    }
    preload(route, fn) {
        const loadRoute = (delay) => {
            if (delay > 0) {
                return timer(delay * 1000).pipe(map(() => fn()));
            }
            else {
                return fn();
            }
        };
        if (route.data && route.data['modulePreload']) {
            const delay = route.data['modulePreloadDelaySeconds'] ? route.data['modulePreloadDelaySeconds'] : 0;
            return loadRoute(delay).pipe(tap(() => {
                if (route.data['moduleName'] === 'bim') {
                    this.appStore.setBimModuleLoaded();
                }
            }));
        }
        return of(null);
    }
}
CustomPreloadingStrategyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomPreloadingStrategyService_Factory() { return new CustomPreloadingStrategyService(i0.ɵɵinject(i1.AppStore)); }, token: CustomPreloadingStrategyService, providedIn: "root" });
